export const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL || "support@study-space.link";

export function replaceSupportEmail(value: string) {
  return value.replaceAll("study.space@agentmail.to", supportEmail);
}
